/**
* Copyright (c) 2018
* @summary TThis file is use under  Setup -> Protocol setup -> element Setup
           Open modal when user click on sub element button after select perticular domain element.
* @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
*
*/
import React, { Component } from 'react';
import { find } from 'lodash';
import { uniq } from 'lodash/array';

import { FormBuilderApi } from '../../../../../../../../api';
import Select from '../../../../../../../../common/data-entry/Select';
import ModalBoxes from '../../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../../../common/general/ButtonGroup';
import NotificationManager from '../../../../../../../../common/notifications/NotificationManager';
import { RichTextEditor } from '../../../../../../../../common/RichTextFormat/editor/RichTextEditor';
import { STYLED_INPUT_QUESTIONS } from '../../../../../../../../constants/inputTypes';
import { FILL_DUPLICATES, FILL_REQUIRED } from '../../../../../../../../constants/notificationMessages';
import { onRequestDefaultError, onRequestError } from '../../../../../../../../services/handlers';
import { getContollTermListDependsPage } from '../../../itemGroupSetupService';

import 'react-super-select/lib/react-super-select.css';
import './SubElementModal.scss';

class SubElementModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subElementformData: {
        formLabel: '',
        answerType: '',
        fieldName: '',
        fieldCdash: '',
        answerCdash: ''
      },
      formLabel: '',
      AnswerTypeList: [
        {
          name: 'CheckList',
          value: 'checkbox'
        },
        {
          name: 'Date',
          value: 'date'
        },
        {
          name: 'DropDown',
          value: 'dropdown'
        },
        {
          name: 'Drop Down Controlled Term',
          value: 'dropdownCT',
          isDefaultSlect: true
        },
        {
          name: 'File Upload',
          value: 'file'
        },
        {
          name: 'Single File Upload',
          value: 'singleFile'
        },
        {
          name: 'Free Text',
          value: 'textbox'
        },
        {
          name: 'Free Text Long',
          value: 'textarea'
        },
        {
          name: 'MultiSelect',
          value: 'multiselect'
        },
        {
          name: 'Multi Select Controlled Term',
          value: 'multiselectCT',
          isDefaultSlect: true
        },
        {
          name: 'Reminder',
          value: 'reminder'
        },

        {
          name: 'Text Block Long',
          value: 'textBlockLong'
        },
        {
          name: 'Text Block',
          value: 'label'
        },
        {
          name: 'Toggle',
          value: 'radio'
        },
        {
          name: 'Time',
          value: 'time'
        }
      ],
      showSubelementHtml: false,
      initialCounter: 0,
      subElementformDataList: [],
      whoCdashList: [],
      whenCdashList: [],
      controlledTermList: [],
      selectedTerm: '',
      fieldValueError: '',
      staticStyledFieldValue: null
    };

    this.maxValueLength = 1000;
  }

  isDropDownAndContainsDuplicatedValues() {
    const dropDownManes = ['multiselect', 'multiselectCT', 'dropdown', 'dropdownCT'];
    return (
      this.state.subElementformDataList.length &&
      this.state.subElementformDataList.some(data => {
        if (!dropDownManes.includes(data.answerType.value)) {
          return false;
        }
        const values = data.answerType.codeDefinationList.map(e => e.decode);
        return values.length !== uniq(values).length;
      })
    );
  }

  validateSubElementData() {
    let isValid = false;
    const validationArry = [];
    this.state.subElementformDataList.length &&
      this.state.subElementformDataList.forEach((data, index) => {
        if (data.answerType.value && STYLED_INPUT_QUESTIONS.includes(data.answerType.value)) {
          if (!data.fieldName.value.trim()) {
            validationArry.push(false);
          } else {
            validationArry.push(true);
          }
        } else if (data.answerType.value && data.answerType.value !== 'select' && data.fieldName.value) {
          if (
            data.answerType.value !== 'label' &&
            data.answerType.value !== 'dropdown' &&
            data.answerType.value !== 'multiselect' &&
            data.answerType.value !== 'multiselectCT' &&
            data.answerType.value !== 'dropdownCT'
          ) {
            if (data.answerType.hasOwnProperty('cdashMappingList') && data.answerType.cdashMappingList.length > 0) {
              if (
                data.answerType.hasOwnProperty('codeDefinationList') &&
                data.answerType.codeDefinationList.length > 0
              ) {
                validationArry.push(true);
              } else {
                validationArry.push(false);
              }
            } else {
              validationArry.push(true);
            }
          } else if (data.answerType.value === 'multiselectCT' || data.answerType.value === 'dropdownCT') {
            if (this.state.selectedTerm) {
              validationArry.push(true);
            } else {
              validationArry.push(false);
            }
            if (
              data.answerType.hasOwnProperty('codeDefinationList') &&
              data.answerType.codeDefinationList.length > 0 &&
              data.answerType.controlledTermValues
            ) {
              validationArry.push(true);
              const sanitizedCodeDefintions = data.answerType.codeDefinationList.filter(code => !!code.name);
              const stateCopy = this.state.subElementformDataList;
              stateCopy[index].answerType.codeDefinationList = sanitizedCodeDefintions;
              this.setState({
                subElementformDataList: stateCopy
              });
            } else {
              validationArry.push(false);
            }
            // remove any blank code entries
          } else if (data.answerType.labelVal) {
            validationArry.push(true);
          } else {
            validationArry.push(false);
          }
        } else {
          validationArry.push(false);
        }
      });
    if (validationArry && validationArry.indexOf(false) > -1) {
      isValid = false;
    } else {
      isValid = true;
    }
    return isValid;
  }

  onChangeToggleValue = (option, index) => {
    if (option && index > -1) {
      if (option.name === 'CLINSIG') {
        this.setState(({ subElementformDataList }) => {
          subElementformDataList[index].answerType.codeDefinationList = [
            {
              name: 'Clinically Significant',
              inputType: 'radio',
              codedValue: 'CS',
              decode: 'CS',
              sequence: 1
            },
            {
              name: 'Not Clinically Significant',
              inputType: 'radio',
              codedValue: 'NCS',
              decode: 'NCS',
              sequence: 2
            }
          ];
          return { subElementformDataList: subElementformDataList };
        });
      } else if (option.name === 'NORMABNM') {
        this.setState(({ subElementformDataList }) => {
          subElementformDataList[index].answerType.codeDefinationList = [
            {
              name: 'Normal',
              inputType: 'radio',
              codedValue: 'NORM',
              decode: 'NORM',
              sequence: 1
            },
            {
              name: 'Abnormal',
              inputType: 'radio',
              codedValue: 'ABNORM',
              decode: 'ABNORM',
              sequence: 2
            }
          ];
          return { subElementformDataList: subElementformDataList };
        });
      } else if (option.name === 'NY') {
        this.setState(({ subElementformDataList }) => {
          subElementformDataList[index].answerType.codeDefinationList = [
            {
              name: 'Yes',
              inputType: 'radio',
              codedValue: 'Y',
              decode: 'Y',
              sequence: 1
            },
            {
              name: 'No',
              inputType: 'radio',
              codedValue: 'N',
              decode: 'N',
              sequence: 2
            }
          ];
          return { subElementformDataList: subElementformDataList };
        });
      } else if (option.name === 'POSNEG') {
        this.setState(({ subElementformDataList }) => {
          subElementformDataList[index].answerType.codeDefinationList = [
            {
              name: 'Positive',
              inputType: 'radio',
              codedValue: 'POS',
              decode: 'POS',
              sequence: 1
            },
            {
              name: 'Negative',
              inputType: 'radio',
              codedValue: 'NEG',
              decode: 'NEG',
              sequence: 2
            }
          ];
          return { subElementformDataList: subElementformDataList };
        });
      }
    }
  };

  addSubElement = () => {
    if (!this.validateSubElementData()) {
      NotificationManager.error(FILL_REQUIRED);
    } else if (this.isDropDownAndContainsDuplicatedValues()) {
      NotificationManager.error(FILL_DUPLICATES);
    } else {
      this.props.onSave && this.props.onSave(this.state);
    }
  };

  onClose = () => {
    this.props.modalBox.close();
  };

  componentDidMount() {
    const tempObj = {
      fieldName: {
        value: ''
      },
      fieldCdash: {
        value: ''
      },
      answerType: {
        value: ''
      },
      answerCdash: {
        value: ''
      }
    };
    FormBuilderApi.getAllCdashMapping().then(res => {
      res &&
        res.data.length &&
        res.data.forEach(d => {
          d.name = d.cdashigVariableLabel;
        });
      this.setState({ whoCdashList: res.data, whenCdashList: res.data });
    }, onRequestError);
    const tempArray = [];
    tempArray.push(tempObj);
    this.setState({ subElementformDataList: tempArray });
  }

  onChangeTermList = (option, pindex, updatedType) => {
    const controlCodeDefinationList = [];
    const tempctMenu = [];
    if (option) {
      option.ctMenu &&
        option.ctMenu.forEach((item, index) => {
          const ControlItem = {
            codeId: 0,
            codeOid: '',
            codedValue: item.ctValue,
            decode: item.ctValue,
            name: item.ctValue,
            inputType: updatedType,
            sequence: index
          };
          controlCodeDefinationList.push(ControlItem);
          tempctMenu.push(item.ctValue);
        });
      const prevSt = this.state.subElementformDataList;
      prevSt[pindex].answerType.standardCodeDefinitionList = controlCodeDefinationList;
      prevSt[pindex].answerType.codeDefinationList = controlCodeDefinationList;
      prevSt[pindex].answerType.controlledTermValues = tempctMenu && tempctMenu.join(',');
      prevSt.ctListName = option.name;
      this.setState({
        selectedTerm: option.name,
        subElementformDataList: prevSt
      });
    }
  };

  onChangeTermValue = (ev, pIndex, updatedType) => {
    const input = ev.target.value.trim();
    const values = input.split(',');
    const controlCodeDefinitionList = [];
    const tempCtMenu = [];
    const originalCodeDefinitions = this.state.subElementformDataList[pIndex].answerType.standardCodeDefinitionList;
    if (values.length > 0) {
      values.forEach((item, index) => {
        item.trim();
        const controlItem = {
          codeId: 0,
          codeOid: '',
          codedValue: item,
          decode: item,
          name: item,
          inputType: updatedType,
          sequence: index
        };
        if (!find(originalCodeDefinitions, controlItem)) {
          controlItem.type = 'custom';
        }
        controlCodeDefinitionList.push(controlItem);
        tempCtMenu.push(item);
      });
      const prevSt = this.state.subElementformDataList;
      prevSt[pIndex].answerType.codeDefinationList = controlCodeDefinitionList;
      prevSt[pIndex].answerType.controlledTermValues = tempCtMenu && tempCtMenu.join(',');
      this.setState({
        subElementformDataList: prevSt
      });
    }
  };

  onChangeDropDown = (option, type, index) => {
    if (option && option.name !== 'Select') {
      const prevSt = this.state.subElementformDataList;
      if (type === 'who_cdash') {
        this.state.subElementformDataList.forEach(() => {
          prevSt[index].fieldCdash.value = option.name;
        });
      } else if (type === 'when_cdash') {
        this.state.subElementformDataList.forEach(() => {
          prevSt[index].answerCdash.value = option.name;
        });
      }
      this.setState({ subElementformDataList: prevSt });
    }
  };

  onChangeStyledText(htmlString, rawTextString, index) {
    this.setState(function(prevState) {
      const subElementFormDataListCopy = [...prevState.subElementformDataList];
      subElementFormDataListCopy[index].fieldName.value = rawTextString;
      subElementFormDataListCopy[index].fieldName.htmlValue = htmlString;
      return { subElementformDataList: subElementFormDataListCopy };
    });
  }

  onChangeText = (e, type, index) => {
    const prevSt = this.state.subElementformDataList;
    this.setStyledFieldNameBasedOnFieldTypeStates(e, type, index, prevSt);
    prevSt[index][`${type}`].value = e.target.value;
    if (type === 'answerType') {
      if (
        prevSt[index][`${type}`] &&
        (prevSt[index][`${type}`].value === 'label' ||
          prevSt[index][`${type}`].value === 'dropdown' ||
          prevSt[index][`${type}`].value === 'multiselect' ||
          prevSt[index][`${type}`].value === 'multiselectCT' ||
          prevSt[index][`${type}`].value === 'dropdownCT')
      ) {
        if (!prevSt[index][`${type}`].hasOwnProperty('labelVal')) {
          prevSt[index][`${type}`].labelVal = '';
        }
        if (prevSt[index][`${type}`].value === 'multiselectCT' || prevSt[index][`${type}`].value === 'dropdownCT') {
          getContollTermListDependsPage.call(this).then(res => {
            prevSt[index][`${type}`].isDefaultSlect = true;
            prevSt[index][`${type}`].controlledTermValues = '';
            if (res && res.data && res.data && res.data.length > 0) {
              res.data.forEach((item, index) => {
                item.id = index;
                item.name = item.ctName;
              });
              this.setState(
                {
                  controlledTermList: res.data
                },
                () => {}
              );
            }
          }, onRequestDefaultError);
        }
      } else {
        delete prevSt[index][`${type}`].labelVal;
      }
      if (prevSt[index][`${type}`] && prevSt[index][`${type}`].value === 'radio') {
        if (!prevSt[index][`${type}`].hasOwnProperty('cdashMappingList')) {
          prevSt[index][`${type}`].cdashMappingList = [
            {
              id: 1,
              name: 'CLINSIG'
            },
            {
              id: 2,
              name: 'NORMABNM'
            },
            {
              id: 3,
              name: 'NY'
            },
            {
              id: 4,
              name: 'POSNEG'
            }
          ];
        }
      } else {
        delete prevSt[index][`${type}`].cdashMappingList;
      }
      if (prevSt[index][`${type}`] && prevSt[index][`${type}`].value === 'checkbox') {
        const checkListObj = {
          codeId: 0,
          codeOid: '',
          codedValue: prevSt[index][`${type}`].value,
          decode: prevSt[index][`${type}`].value,
          inputType: prevSt[index][`${type}`].value,
          name: prevSt[index][`${type}`].value,
          sequence: 1
        };
        prevSt[index].answerType.codeDefinationList = [checkListObj];
      } else {
        delete prevSt[index][`${type}`].codeDefinationList;
      }
    }
    this.setState({ subElementformDataList: prevSt });
  };

  setStyledFieldNameBasedOnFieldTypeStates = (e, type, index, prevSt) => {
    if (type === 'answerType') {
      if (
        STYLED_INPUT_QUESTIONS.includes(prevSt[index].answerType.value) &&
        !STYLED_INPUT_QUESTIONS.includes(e.target.value)
      ) {
        prevSt[index].fieldName.htmlValue = null;
        this.setState({ staticStyledFieldValue: null });
      }

      if (
        !STYLED_INPUT_QUESTIONS.includes(prevSt[index].answerType.value) &&
        STYLED_INPUT_QUESTIONS.includes(e.target.value)
      ) {
        prevSt[index].fieldName.htmlValue = prevSt[index].fieldName.value;
        this.setState({ staticStyledFieldValue: prevSt[index].fieldName.value });
      }
    }
  };

  onChangeLabel = e => {
    this.setState({ formLabel: e.target.value });
  };

  onChangeSetLabel = (e, type, index, answerTypeVal) => {
    try {
      const prevSt = this.state.subElementformDataList;
      prevSt[index][`${type}`].labelVal = e.target.value;
      let fieldValueError = '';
      if (prevSt[index][`${type}`].value === 'dropdown' || prevSt[index][`${type}`].value === 'multiselect') {
        const dropdownOptionArray = e.target.value.trim() && e.target.value.split(',');
        prevSt[index][`${type}`].labelVal = dropdownOptionArray;
        const codeDefinationForDropdown = [];
        dropdownOptionArray &&
          typeof dropdownOptionArray === 'object' &&
          dropdownOptionArray.forEach(item => {
            if (item) {
              if (item.length <= this.maxValueLength) {
                const dropDownObj = {
                  codeId: 0,
                  codeOid: '',
                  codedValue: item,
                  decode: item,
                  inputType: prevSt[index][`${type}`].value,
                  name: item,
                  sequence: 1
                };
                codeDefinationForDropdown.push(dropDownObj);
              } else {
                fieldValueError = 'Values can not exceed 1000 Characters';
              }
            }
          });
        prevSt[index].answerType.codeDefinationList = codeDefinationForDropdown;
      }
      this.setState({ subElementformDataList: prevSt, fieldValueError });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { state } = this;
    return (
      <>
        <ModalBoxes.Header>Add Item</ModalBoxes.Header>
        <ModalBoxes.Body>
          <div hidden className="form-group row flable">
            <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
              Form Label
            </label>
            <div className="col-sm-9 p-0">
              <input
                className="form-control col-sm-5 p-0"
                type="text"
                name="formLabel"
                value={state.formLabel}
                onChange={this.onChangeLabel}
              />
            </div>
          </div>
          <div className="popScroll">
            {this.state.subElementformDataList.map((subEle, pindex) => {
              return (
                <React.Fragment key={pindex}>
                  <div className="form-group row">
                    <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                      Answer Type
                    </label>
                    <div className="col-sm-9 p-0">
                      <select
                        className="form-control col-sm-5 p-0 reqfeild"
                        name="answerType"
                        value={subEle.answerType.value}
                        onChange={event => this.onChangeText(event, 'answerType', pindex)}
                      >
                        <option value="select"> Select </option>
                        {this.state.AnswerTypeList.map((item, index) => {
                          return (
                            <option key={index} value={item.value}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  {subEle.answerType.value !== 'textBlockLong' && subEle.answerType.value !== 'textarea' && (
                    <div className="form-group row">
                      <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                        Field Name
                      </label>
                      <div className="col-sm-8 p-0">
                        <textarea
                          rows="2"
                          className="form-control reqfeild"
                          name="fieldName"
                          value={subEle.fieldName.value}
                          onChange={event => this.onChangeText(event, 'fieldName', pindex)}
                        />
                      </div>
                    </div>
                  )}
                  {STYLED_INPUT_QUESTIONS.includes(subEle.answerType.value) && (
                    <div className="form-group row">
                      <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                        Field Name
                      </label>
                      <div className="col-sm-8 p-0">
                        <RichTextEditor
                          className={'regular-item-group create'}
                          value={this.state.staticStyledFieldValue}
                          onChange={(htmlString, rawTextString) =>
                            this.onChangeStyledText(htmlString, rawTextString, pindex)
                          }
                        />
                      </div>
                    </div>
                  )}
                  {subEle.answerType.hasOwnProperty('labelVal') && subEle.answerType.value === 'label' && (
                    <div className="form-group row">
                      <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                        Field Value
                      </label>
                      <div className="col-sm-9 p-0">
                        <textarea
                          row="4"
                          maxLength="3000"
                          className="form-control col-sm-8 p-0 reqfeild"
                          name="fieldName"
                          type="text"
                          value={subEle.answerType.labelVal}
                          onChange={event =>
                            this.onChangeSetLabel(
                              event,
                              'answerType',
                              pindex,
                              subEle.answerType && subEle.answerType.value
                            )
                          }
                        />
                      </div>
                    </div>
                  )}
                  {subEle.answerType.hasOwnProperty('labelVal') &&
                    (subEle.answerType.value === 'dropdown' || subEle.answerType.value === 'multiselect') && (
                      <div className="form-group row">
                        <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                          Field Value
                        </label>
                        <div className="col-sm-9 p-0">
                          <textarea
                            row="4"
                            maxLength="3000"
                            className="form-control col-sm-8 p-0 reqfeild"
                            name="fieldName"
                            type="text"
                            value={subEle.answerType.labelVal}
                            onChange={event =>
                              this.onChangeSetLabel(
                                event,
                                'answerType',
                                pindex,
                                subEle.answerType && subEle.answerType.value
                              )
                            }
                          />
                          <div className="fvalMsg"> * Please enter comma seperated value for dropdown options</div>
                          {this.state.fieldValueError && (
                            <div className="error-msg-small">* {this.state.fieldValueError}</div>
                          )}
                        </div>
                      </div>
                    )}
                  {subEle.answerType.hasOwnProperty('labelVal') &&
                    (subEle.answerType.value === 'multiselectCT' || subEle.answerType.value === 'dropdownCT') &&
                    subEle.answerType.isDefaultSlect && (
                      <div className="form-group row">
                        <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                          Term List
                        </label>
                        <div className="col-sm-9 p-0">
                          <Select
                            placeholder="Select"
                            clearSearchOnSelection
                            dataSource={this.state.controlledTermList}
                            onChange={option =>
                              this.onChangeTermList(
                                option,
                                pindex,
                                subEle.answerType.value === 'multiselectCT' ? 'multiselect' : 'dropdown'
                              )
                            }
                            searchable
                            keepOpenOnSelection={false}
                            closeOnSelectedOptionClick
                            deselectOnSelectedOptionClick={false}
                            className="col-sm-5 p-0 reqfeild"
                            legacyLook
                            customSelectedValueTemplateFunction={this.customSelectedValueTemplateFunction}
                            clearable={false}
                          />
                        </div>
                      </div>
                    )}
                  {subEle.answerType.hasOwnProperty('labelVal') &&
                    (subEle.answerType.value === 'multiselectCT' || subEle.answerType.value === 'dropdownCT') &&
                    subEle.answerType.isDefaultSlect && (
                      <div className="form-group row">
                        <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                          Term Value
                        </label>
                        <div className="col-sm-9 p-0">
                          <textarea
                            className="controllTerm reqfeild"
                            value={subEle.answerType.controlledTermValues}
                            onChange={e => {
                              this.onChangeTermValue(
                                e,
                                pindex,
                                subEle.answerType.value === 'multiselectCT' ? 'multiselect' : 'dropdown'
                              );
                            }}
                          />
                        </div>
                      </div>
                    )}
                  {subEle.answerType.cdashMappingList && subEle.answerType.cdashMappingList.length > 0 && (
                    <div className="form-group row">
                      <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right">
                        Value
                      </label>
                      <div className="col-sm-9 p-0">
                        <Select
                          clearSearchOnSelection
                          dataSource={subEle.answerType.cdashMappingList}
                          onChange={option => this.onChangeToggleValue(option, pindex)}
                          searchable
                          keepOpenOnSelection={false}
                          closeOnSelectedOptionClick
                          deselectOnSelectedOptionClick={false}
                          className="col-sm-5 p-0 reqfeild"
                          legacyLook
                          placeholder="Select drop status"
                          customSelectedValueTemplateFunction={this.customSelectedValueTemplateFunction}
                          clearable={false}
                        />
                      </div>
                    </div>
                  )}
                  <div className="form-group row">
                    <label htmlFor="staticEmail" className="col-sm-3 col-form-label text-right pt-2">
                      CDASH Mapping
                    </label>
                    <div className="col-sm-9 p-0">
                      <Select
                        placeholder="Select"
                        clearSearchOnSelection
                        dataSource={this.state.whoCdashList ? this.state.whoCdashList : []}
                        onChange={option => this.onChangeDropDown(option, 'when_cdash', pindex)}
                        searchable
                        keepOpenOnSelection={false}
                        closeOnSelectedOptionClick
                        deselectOnSelectedOptionClick={false}
                        className="col-sm-5 p-0"
                        legacyLook
                        customSelectedValueTemplateFunction={this.customSelectedValueTemplateFunction}
                        clearable={false}
                      />
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </ModalBoxes.Body>

        <ModalBoxes.Footer>
          <ButtonGroup>
            <Button priority="medium" onClick={this.onClose}>
              Cancel
            </Button>
            <Button onClick={this.addSubElement} disabled={!!this.state.fieldValueError}>
              Add
            </Button>
          </ButtonGroup>
        </ModalBoxes.Footer>
      </>
    );
  }
}

SubElementModal.className = 'element-setup-modals';
SubElementModal.size = 'w650';

export default SubElementModal;
